import styled from 'styled-components';

import { SkeletonRectangle, SkeletonTag } from '@xing-com/skeleton';
import { scale130, scale080, scale060, scale020 } from '@xing-com/tokens';

const SkeletonContainer = styled.div`
  flex: 1;
  margin: 0 ${scale080};
`;

const StyledSkeletonRectangle = styled(SkeletonRectangle)`
  width: 240px;
  height: 320px;
  border-radius: ${scale130};
`;

const SkeletonRow = styled.div`
  display: flex;
  width: 100%;
  margin-top: ${scale060};
`;

const StyledSkeletonTag = styled(SkeletonTag)`
  width: 118px;
  margin-right: ${scale020};
`;

export const Skeleton: React.FC<{ dataQa?: string }> = ({ dataQa }) => (
  <SkeletonContainer data-qa={dataQa}>
    <StyledSkeletonRectangle />
    <SkeletonRow>
      <StyledSkeletonTag />
      <StyledSkeletonTag />
    </SkeletonRow>
  </SkeletonContainer>
);
